export default (function () {
    var items = [{
        name: 'dashboard',
        url: '/dashboard',
        icon: 'icon-speedometer',
    }, {
        name: 'chatbot',
        url: '/chatbot',
        icon: 'icon-bubbles',
    }, {
        name: 'services',
        icon: 'icon-puzzle',
        url: '/services',
    }, {
        name: 'scenario',
        icon: 'icon-puzzle',
        url: '/scenario',
    }, {
        name: 'Subscription',
        icon: 'icon-puzzle',
        url: '/subscription',
    }, {
        name: 'datasets',
        icon: 'icon-puzzle',
        url: '/dataset',
    }, {
        name: 'menus',
        icon: 'icon-puzzle',
        url: '/menus',
    }, {
        name: 'Datasources',
        icon: 'icon-puzzle',
        url: '/datasources',
    }, {
        name: 'Settings',
        icon: 'icon-settings',
        url: '/settings',
    }, {
        name: 'Logout',
        icon: 'icon-logout',
        url: '/user/logout',
    }]
    if (process.env.VUE_APP_APP_DEBUG && !process.env.VUE_APP_UPDATED_NAV) {
        process.env.VUE_APP_UPDATED_NAV = 1
        items = items.slice().splice(0, items.length - 1).concat({
            name: 'debugger',
            icon: 'icon-equalizer',
            url: '/debugger',
        }, items[items.length - 1])
    }
    return {
        items
    }
}())
